export default {
  '阳光跑班级报表': '阳光跑班级报表',
  '阳光跑个人报表': '阳光跑个人报表',
  '班级报表': '班级报表',
  '学生报表': '学生报表',
  '跑步人数': '跑步人数',
  '未跑人数': '未跑人数',
  '人均里程': '人均里程',
  '班级详情': '班级详情',
  '导出未跑名单': '导出未跑名单',
  '个人报告': '个人报告',
  '运动时长': '运动时长',
  '运动次数': '运动次数',
  '功能开发中': '功能开发中'
}
